import axios from "axios";

const axiosInstance = axios.create({
  // baseURL: 'http://localhost:5000/api',
  // baseURL: "https://back.autoshkollaime.com/api",
  baseURL: "https://back2.autoshkollaime.com/api",
  timeout: 10000,
  headers: {
    "Content-Type": "application/x-www-form-urlencoded",
    Accept: "application/json",
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("userToken");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axiosInstance;
